// extracted by mini-css-extract-plugin
module.exports = {"podcastsHeader":"PodcastsHeader-module--podcasts-header--KWZH4","podcastsHeader__image":"PodcastsHeader-module--podcasts-header__image--2nq0Q"};